import { Stack } from "@mui/material";
import { ReactNode } from "react";

import { ComponentDownloadActionButton, ComponentUploadActionButtonWithModal } from "./ComponentActionButton";

export interface ComponentsCommonHeaderProps {
  action?: () => void;
  actionIsDisabled?: boolean;
  actionText?: string;
  className?: string;
  hasActionAccess?: boolean;
  title?: ReactNode;
}

export interface ComponentsHeaderWithDownloadUploadActionProps {
  className?: string;
  downloadAction?: () => void;
  downloadActionIsDisabled?: boolean;
  downloadActionText?: string;
  hasDownloadAccess?: boolean;
  hasUploadAccess?: boolean;
  onUploadClick?: () => void;
  onUploadDone?: () => void;
  title?: ReactNode;
  uploadFileMetaDataAPI?: {
    getFileMetaDataBody: (file: File) => any;
    url: string;
  };
  uploadFormDataFileKeyName: string;
  uploadQueryParams: ((fileMetaData: any) => { name: string; value: string }[]) | { name: string; value: string }[];
  uploadRenderModalBody: () => ReactNode;
  uploadUrl?: string;
}

export const ComponentsCommonHeader = ({
  action = () => {},
  actionIsDisabled = false,
  actionText = "",
  className = "",
  hasActionAccess = undefined,
  title = "",
}: ComponentsCommonHeaderProps) => {
  return (
    <ComponentsCommonHeaderBasic
      actionComponent={
        hasActionAccess && (
          <ComponentDownloadActionButton action={action} actionIsDisabled={actionIsDisabled} actionText={actionText} />
        )
      }
      className={className}
      title={title}
    />
  );
};

export const ComponentsHeaderWithDownloadUploadAction = ({
  className,
  downloadAction,
  downloadActionIsDisabled,
  downloadActionText,
  hasDownloadAccess,
  hasUploadAccess,
  onUploadClick,
  onUploadDone,
  title,
  uploadFileMetaDataAPI,
  uploadFormDataFileKeyName,
  uploadQueryParams,
  uploadRenderModalBody,
  uploadUrl,
}: ComponentsHeaderWithDownloadUploadActionProps) => {
  return (
    <ComponentsCommonHeaderBasic
      actionComponent={
        <Stack>
          {hasUploadAccess && (
            <ComponentUploadActionButtonWithModal
              fileMetaDataAPI={uploadFileMetaDataAPI}
              formDataFileKeyName={uploadFormDataFileKeyName}
              onSuccess={onUploadDone}
              onUploadClick={onUploadClick}
              queryParams={uploadQueryParams}
              renderModalBody={uploadRenderModalBody}
              url={uploadUrl ?? ""}
            />
          )}
          {hasDownloadAccess && (
            <ComponentDownloadActionButton
              action={downloadAction}
              actionIsDisabled={downloadActionIsDisabled}
              actionText={downloadActionText}
            />
          )}
        </Stack>
      }
      className={className}
      title={title}
    />
  );
};

export const ComponentsCommonHeaderBasic = ({
  actionComponent,
  className,
  description,
  title,
}: {
  actionComponent: ReactNode;
  className?: string;
  description?: ReactNode;
  title: ReactNode;
}) => {
  return (
    <Stack className={`items-start justify-between py-3 ${className}`}>
      <Stack className="flex-col items-start gap-1">
        <h2 className="font-ds-headline-lg  ">{title}</h2>
        {description && <p className="text-lds-foreground-muted font-ds-body-regular-xs">{description}</p>}
      </Stack>
      {actionComponent}
    </Stack>
  );
};
